import { useEffect, useState, useRef } from "react";
import axiosInstance from "../api/axios";

import SearchBox from "./SearchBox";

function ShareModalOld({ token, post, onClose }) {
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [selectPartner, setSelectPartner] = useState(null);
  const [message, setMessage] = useState("");
  const [sendMessageFn, setSendMessageFn] = useState(null);

  const handleSelectPartner = (profile) => {
    setSelectedPartners((prev) => [...prev, profile.user]);
    setSelectPartner(profile.user);
  };

  // useEffect(() => {
  //   if (!selectPartner) return;

  //   setSendMessageFn(() => sendMessage);
  // }, [token, selectPartner]);

  // const { sendMessage } = useChatSocket(token, selectPartner, (msg) => {});

  const handleSend = (e) => {
    e.preventDefault();
    // if (!sendMessage || !selectPartner) {
    //   console.warn("No WebSocket connection established yet.");
    //   return;
    // }
    const msg = `/posts/${post.id} \n ${message.trim()}`;
    sendMessageFn(msg);
  };

  return (
    // {/* modal main */}
    <div
      className="flex flex-col items-center bg-white max-w-xl min-w-[500px] max-h-[60vh] w-full relative overflow-hidden h-[60vh]"
      onClick={(e) => e.stopPropagation()}
    >
      <SearchBox onItemClick={handleSelectPartner} />

      {selectPartner && (
        <form onSubmit={handleSend} className="mt-4 flex max-w-xl space-x-2">
          <input
            type="text"
            className="flex-1 border rounded px-3 py-2"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message"
          />
          <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
            Send
          </button>
        </form>
      )}
    </div>
  );
}

export default function ShareModal({ token, post, onClose }) {
  const baseURL = window.location.host;

  const handleCopy = () => {
    navigator.clipboard.writeText(`${baseURL}/posts/${post.id}`);
    alert("Copied!");
  };

  return (
    <div
      className="bg-white rounded-t-lg sm:rounded-lg w-full sm:w-96 p-4 space-y-4 shadow-lg"
      onClick={(e) => e.stopPropagation()}
    >
      <button onClick={handleCopy} className="w-full py-2 border-b">
        Copy Link
      </button>
      <button onClick={onClose} className="w-full py-2 font-semibold text-gray-700">
        Cancel
      </button>
    </div>
  );
}
